import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    wrapper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      position: "relative",
      minWidth: 100,
      height: "100%",
    },
    container: {
      flex: 1,
    },
    innerContainer: {
      position: "relative",
      flex: 1,
    },
    label: {
      position: "absolute",
      top: spacing.xs,
      left: spacing.s,
      pointerEvents: "none",
    },
    inputContainer: {
      backgroundColor: theme.input.background,
      borderRadius: constants.radius.view,
    },
    select: {
      all: "unset",
      paddingTop: spacing.xxl,
      paddingBottom: spacing.m,
      paddingLeft: spacing.s,
      width: "100%",
      appearance: "none",
      WebkitAppearance: "none",
      MozAppearance: "none",
      cursor: "pointer",
      color: theme.input.text,
    },
    right: {
      display: "flex",
      alignSelf: "center",
      transform: "translateY(-50%)",
      pointerEvents: "none",
      marginRight: 16,
      marginTop: 4,
    },
    item: {
      borderBottom: `1px solid ${theme.border}`,
      width: "100%",
      textAlign: "center",
      fontFamily: `"Inter", sans-serif`,
      paddingTop: spacing.xs,
      paddingBottom: spacing.xs,
      cursor: "pointer",
      userSelect: "none",
    },
    disabled: {
      opacity: 0.5,
    },
  };

  return styles;
};
